var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNounAssign = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "currentcolor",
  viewBox: "0 0 22 22",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 16.197a6.84 6.84 0 0 1-5 2.167 6.84 6.84 0 0 1-5-2.167v-.288C6 14.855 6.746 14 7.667 14h6.666c.92 0 1.667.855 1.667 1.91zM9.081 5.313c.507.672.031 1.633-.808 1.633H3.177c-.68 0-1.171-.652-.984-1.305L3.596.752a1.01 1.01 0 0 1 .788-.727 1.021 1.021 0 0 1 1.014.399l1.123 1.49A10.44 10.44 0 0 1 11 .91c5.799 0 10.5 4.721 10.5 10.546S16.799 22 11 22 .5 17.279.5 11.455c0-.728.588-1.319 1.313-1.319.724 0 1.312.59 1.312 1.319 0 4.368 3.526 7.909 7.875 7.909s7.875-3.541 7.875-7.91S15.349 3.546 11 3.546c-.992 0-1.955.185-2.848.533zM11 13a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
})));
export { SvgNounAssign as ReactComponent };
export default __webpack_public_path__ + "assets/images/noun-assign.svg";